/* /pages/calm-offer (Happy-Furever Buy 2 Get 1 Free). Generated into assets/po-co.js by hf-bundle-offer/build/build.py. */
(function () {
  'use strict';
  var doc = document;
  var dl = (window.dataLayer = window.dataLayer || []);
  var each = function (list, fn) { Array.prototype.forEach.call(list || [], fn); };
  var sectionOf = function (el) { var h = el && el.closest ? el.closest('[data-ao-section]') : null; return h ? h.getAttribute('data-ao-section') : ''; };
  var dataEl = doc.querySelector('[data-co-data]');
  var D = null;
  try { D = JSON.parse(dataEl.textContent); } catch (e) {}
  var FUNNEL = (D && D.funnel) || 'calm-offer';
  var PAGE = window.location.pathname;

  /* Gallery (phone thumb strip) */
  var galMain = doc.querySelector('[data-co-gal-main]'), galImg = doc.querySelector('[data-co-gal-img]');
  var thumbs = doc.querySelectorAll('[data-co-thumb]');
  each(thumbs, function (b, i) {
    b.addEventListener('click', function () {
      if (galImg) galImg.src = b.getAttribute('data-co-thumb');
      if (galMain) galMain.classList.toggle('is-alt', i !== 0);
      each(thumbs, function (x) { x.classList.toggle('is-on', x === b); });
    });
  });

  /* Reviews: Show More / Show Less */
  each(doc.querySelectorAll('[data-ao-more]'), function (b) {
    b.addEventListener('click', function () {
      var l = b.parentNode.querySelector('[data-ao-rlist]');
      if (!l) return;
      var open = !l.classList.contains('is-open');
      l.classList.toggle('is-open', open);
      b.textContent = open ? (b.getAttribute('data-less') || 'Show Less') : (b.getAttribute('data-more') || 'Show More');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) { var top = l.getBoundingClientRect().top; if (top < 0) window.scrollTo({ top: top + window.scrollY - 16, behavior: 'smooth' }); }
      dl.push({ event: open ? 'po_offer_reviews_more' : 'po_offer_reviews_less', funnel: FUNNEL });
    });
  });

  /* Gallery viewer (Mike, 21 Oct): desktop only (900px+, where the gallery is a grid); phones keep the thumb carousel untouched */
  (function () {
    var thumbsAll = doc.querySelectorAll('[data-co-thumb]');
    var srcs = [], alts = [];
    each(thumbsAll, function (b) { srcs.push(b.getAttribute('data-co-thumb').replace(/([?&]width=)\d+/, '$11600')); });  /* Files images: ask for a sharper copy */
    var zoomEls = doc.querySelectorAll('[data-mo-zoom]');
    if (!srcs.length || !zoomEls.length) return;
    each(zoomEls, function (el) {
      var k = el.getAttribute('data-mo-zoom'); var i = k === 'main' ? 0 : +k; alts[i] = el.getAttribute('alt') || '';
    });
    var lb = doc.createElement('div');
    lb.className = 'mo-lb'; lb.hidden = true;
    lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Product images');
    lb.innerHTML = '<button type="button" class="mo-lb__close" aria-label="Close">&times;</button>'
      + '<button type="button" class="mo-lb__nav mo-lb__prev" aria-label="Previous image">&#8249;</button>'
      + '<figure class="mo-lb__fig"><img class="mo-lb__img" alt=""><figcaption class="mo-lb__count"></figcaption></figure>'
      + '<button type="button" class="mo-lb__nav mo-lb__next" aria-label="Next image">&#8250;</button>';
    doc.body.appendChild(lb);
    var im = lb.querySelector('.mo-lb__img'), cnt = lb.querySelector('.mo-lb__count'), cur = 0, lastFocus = null;
    var show = function (i) {
      cur = (i + srcs.length) % srcs.length;
      im.src = srcs[cur]; im.alt = alts[cur] || '';
      cnt.textContent = (cur + 1) + ' / ' + srcs.length;
    };
    var open = function (i) {
      lastFocus = doc.activeElement; show(i); lb.hidden = false;
      doc.documentElement.classList.add('mo-lb-open'); lb.querySelector('.mo-lb__close').focus();
      dl.push({ event: 'po_offer_gallery_zoom', funnel: FUNNEL, image: cur + 1 });
    };
    var close = function () { lb.hidden = true; doc.documentElement.classList.remove('mo-lb-open'); if (lastFocus && lastFocus.focus) lastFocus.focus(); };
    var mq = window.matchMedia('(min-width: 900px)');
    var arm = function () {
      each(zoomEls, function (el) {
        if (mq.matches) { el.setAttribute('role', 'button'); el.setAttribute('tabindex', '0'); el.setAttribute('aria-label', 'Enlarge image: ' + (el.getAttribute('alt') || 'product image')); }
        else { el.removeAttribute('role'); el.removeAttribute('tabindex'); el.removeAttribute('aria-label'); }
      });
      if (!mq.matches && !lb.hidden) close();
    };
    each(zoomEls, function (el) {
      var go = function () {
        if (!mq.matches) return;
        var k = el.getAttribute('data-mo-zoom'), i = 0;
        if (k === 'main') { each(thumbsAll, function (b, n) { if (b.classList.contains('is-on')) i = n; }); } else { i = +k; }
        open(i);
      };
      el.addEventListener('click', go);
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
    });
    arm();
    if (mq.addEventListener) mq.addEventListener('change', arm); else if (mq.addListener) mq.addListener(arm);
    var hint = doc.querySelector('.mo-zoomhint');
    if (hint) hint.addEventListener('click', function () { var m = doc.querySelector('[data-mo-zoom="main"]'); if (m) m.click(); });
    lb.querySelector('.mo-lb__close').addEventListener('click', close);
    lb.querySelector('.mo-lb__prev').addEventListener('click', function () { show(cur - 1); });
    lb.querySelector('.mo-lb__next').addEventListener('click', function () { show(cur + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('mo-lb__fig')) close(); });
    doc.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close(); else if (e.key === 'ArrowLeft') show(cur - 1); else if (e.key === 'ArrowRight') show(cur + 1);
      else if (e.key === 'Tab') { var f = lb.querySelectorAll('button'), a = f[0], z = f[f.length - 1]; if (e.shiftKey && doc.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && doc.activeElement === z) { e.preventDefault(); a.focus(); } }
    });
    var sx = null;
    lb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 45) show(cur + (dx < 0 ? 1 : -1)); sx = null; });
  })();

  /* Section CTAs scroll to the buy box */
  doc.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-ao-cta]') : null;
    if (!a) return;
    e.preventDefault();
    var o = doc.getElementById('offer');
    if (o) window.scrollTo({ top: o.getBoundingClientRect().top + window.scrollY - 8, behavior: 'smooth' });
    dl.push({ event: 'po_offer_cta_click', funnel: FUNNEL, section: sectionOf(a) });
  });

  /* Site footer newsletter field: floating label, as on the main theme */
  each(doc.querySelectorAll('.ao-sitefooter .input-wrapper'), function (w) {
    var i = w.querySelector('input'); if (!i) return;
    var sync = function () { w.classList.toggle('is-empty', !i.value); };
    i.addEventListener('focus', function () { w.classList.add('in-focus'); });
    i.addEventListener('blur', function () { w.classList.remove('in-focus'); sync(); });
    i.addEventListener('input', sync); sync();
  });

  /* Section views */
  if ('IntersectionObserver' in window) {
    var seen = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var id = en.target.getAttribute('data-ao-section');
        if (!en.isIntersecting || seen[id]) return;
        if (en.intersectionRatio >= 0.5 || en.intersectionRect.height >= window.innerHeight * 0.5) {
          seen[id] = true; dl.push({ event: 'po_offer_section_view', funnel: FUNNEL, section: id }); io.unobserve(en.target);
        }
      });
    }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
    each(doc.querySelectorAll('[data-ao-section]'), function (s) { io.observe(s); });
  }

  /* Ships-by date: today + 5 business days (shipping policy: processed within 1 to 5 business days) */
  each(doc.querySelectorAll('[data-co-shipdate]'), function (el) {
    try {
      var d = new Date(), n = 0;
      while (n < 5) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n++; }
      el.innerHTML = 'by <mark>' + d.toLocaleDateString('en-US', { weekday: 'long' }) + ', ' + d.getDate() + ' ' + d.toLocaleDateString('en-US', { month: 'long' }) + '</mark>';
    } catch (e) {}
  });

  /* ---------- Buy box ---------- */
  var box = doc.querySelector('[data-co-buy]');
  if (!D || !box) return;
  var q = new URLSearchParams(window.location.search);
  var state = {
    tier: D.tiers['t' + q.get('tier')] ? 't' + q.get('tier') : D.defaultTier,
    refill: q.get('refill') !== '0'
  };
  var busy = false;
  var money = function (c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
  var subPrice = function (t) { return Math.round(t.price * (100 - D.subPct) / 100); };
  var priceOf = function (t, refill) { return refill ? subPrice(t) : t.price; };
  var struckOf = function (t) { return D.struckPerBottle * t.bottles; };
  var pct = function (p, t) { return Math.round((1 - p / struckOf(t)) * 100); };
  var setF = function (root, f, html) { each(root.querySelectorAll('[data-co-f="' + f + '"]'), function (el) { el.innerHTML = html; }); };

  var render = function () {
    each(box.querySelectorAll('[data-co-tier]'), function (card) {
      var key = card.getAttribute('data-co-tier'), t = D.tiers[key], on = key === state.tier, p = priceOf(t, state.refill);
      card.classList.toggle('is-on', on); card.setAttribute('aria-checked', on ? 'true' : 'false');
      setF(card, 'save', 'SAVE ' + pct(p, t) + '%');
      setF(card, 'mo', money(Math.round(p / t.months)));
      setF(card, 'bill', state.refill ? 'Billed ' + money(p) + ' ' + t.every : 'Paid once: ' + money(p));
      setF(card, 'perday', money(Math.round(p / t.days)));
    });
    var cur = D.tiers[state.tier];
    var refillBtn = box.querySelector('[data-co-refill]');
    if (refillBtn) { refillBtn.classList.toggle('is-on', state.refill); refillBtn.setAttribute('aria-checked', state.refill ? 'true' : 'false'); }
    setF(box, 'refillsave', pct(subPrice(cur), cur) + '%');
    setF(box, 'refillnote', 'Ships ' + cur.every + '. Zero commitment, skip or cancel anytime.');
    setF(box, 'cta', cur.cta + ' | ' + money(priceOf(cur, state.refill)));
    try {
      var u = new URL(window.location.href);
      u.searchParams.set('tier', state.tier.slice(1));
      if (state.refill) u.searchParams.delete('refill'); else u.searchParams.set('refill', '0');
      window.history.replaceState(null, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  };

  var showError = function (msg) { each(box.querySelectorAll('[data-co-error]'), function (el) { el.textContent = msg; el.hidden = !msg; }); };
  var setBusy = function (on) {
    busy = on;
    each(box.querySelectorAll('[data-co-checkout]'), function (b) { b.disabled = on; b.classList.toggle('is-loading', on); b.setAttribute('aria-busy', on ? 'true' : 'false'); });
  };

  /* Cart guard: while checking out, drop add/change requests from other scripts (Intelligems' gift-with-purchase) */
  (function () {
    var isMut = function (u) { return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(u || '')); };
    var origFetch = window.fetch;
    if (origFetch) {
      window.fetch = function (input, init) {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        if (busy && isMut(u)) {
          dl.push({ event: 'po_offer_cart_guard', funnel: FUNNEL, url: String(u).slice(0, 80) });
          return Promise.resolve(new Response('{"items":[],"item_count":0}', { status: 200, headers: { 'Content-Type': 'application/json' } }));
        }
        return origFetch.apply(this, arguments);
      };
    }
    var origOpen = XMLHttpRequest.prototype.open, origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__poUrl = u; return origOpen.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      if (busy && isMut(this.__poUrl)) { dl.push({ event: 'po_offer_cart_guard', funnel: FUNNEL, url: String(this.__poUrl).slice(0, 80) }); return; }
      return origSend.apply(this, arguments);
    };
  })();

  /* Checkout: one server-side navigation chain, so no cart app can change the order on the way:
     /cart/clear -> /cart/update (attributes) -> /cart/add (bundle + plan + gifts) -> /discount/CODE -> /checkout */
  var checkout = function (origin) {
    if (busy) return;
    var t = D.tiers[state.tier];
    if (!t || !t.variant) { showError('Sorry, this option is unavailable. Please pick another.'); return; }
    if (state.refill && !t.plan) { showError('Sorry, automatic refills are not available for this bundle yet. Untick refills or pick another bundle.'); return; }
    var gifts = [];
    if (t.gifts.indexOf('bundle') > -1 && D.gifts.bundle) gifts.push(D.gifts.bundle);
    if (t.gifts.indexOf('primal') > -1 && D.gifts.primal) gifts.push(D.gifts.primal);
    var attrs = { funnel: FUNNEL, landing_page: PAGE, offer_tier: t.name, offer_bottles: String(t.bottles), offer_mode: state.refill ? 'sub' : 'once' };
    if (t.gifts.indexOf('voucher') > -1) attrs.offer_voucher = money(D.gifts.voucherValue) + ' cash voucher';
    var incoming = new URLSearchParams(window.location.search);
    if (incoming.get('funnel') && incoming.get('funnel') !== FUNNEL) attrs.entry_funnel = incoming.get('funnel');
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'].forEach(function (k) { if (incoming.get(k)) attrs[k] = incoming.get(k); });
    var gos = window.GrowthOS && window.GrowthOS.get ? window.GrowthOS.get() : null;
    if (gos && gos.shot_id) { attrs.shot_id = gos.shot_id; attrs.chain_variant = gos.chain_variant || ''; attrs.step_variant = gos.step_variant || ''; attrs.first_touch_ts = gos.first_touch_ts || ''; }
    showError(''); setBusy(true);
    dl.push({ event: 'po_offer_checkout', funnel: FUNNEL, section: sectionOf(origin), tier: t.name, bottles: t.bottles, plan: attrs.offer_mode, value: priceOf(t, state.refill) / 100, currency: 'USD' });
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .catch(function () { return {}; })
      .then(function (cart) {
        var igOffer = cart && cart.attributes && cart.attributes.igOffers ? String(cart.attributes.igOffers).split(',')[0] : '';
        var qs = new URLSearchParams(); var n = 0;
        var addLine = function (id, qty, plan, props) {
          qs.append('items[' + n + '][id]', String(id)); qs.append('items[' + n + '][quantity]', String(qty));
          if (plan) qs.append('items[' + n + '][selling_plan]', String(plan));
          Object.keys(props || {}).forEach(function (k) { qs.append('items[' + n + '][properties][' + k + ']', props[k]); });
          n++;
        };
        addLine(t.variant, 1, state.refill ? t.plan : '', null);
        gifts.forEach(function (id) { addLine(id, 1, '', String(id) === String(D.gifts.bundle) && igOffer ? { _igGWP: igOffer, _igGWPTier: '0' } : null); });
        var attrStep = function (next) { var u = new URLSearchParams(); Object.keys(attrs).forEach(function (k) { u.append('attributes[' + k + ']', attrs[k]); }); u.append('return_to', next); return '/cart/update?' + u.toString(); };
        var dest = D.shipCode ? '/discount/' + encodeURIComponent(D.shipCode) + '?redirect=/checkout' : '/checkout';
        qs.append('return_to', attrStep(dest));
        window.location.href = '/cart/clear?return_to=' + encodeURIComponent(attrStep('/cart/add?' + qs.toString()));
      })
      .catch(function (err) {
        setBusy(false); showError('Sorry, we could not add your order. Please try again.');
        dl.push({ event: 'po_offer_checkout_error', funnel: FUNNEL, message: String(err && err.message || err) });
      });
  };

  box.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null; if (!t) return;
    var b;
    if ((b = t.closest('[data-co-tier]'))) { state.tier = b.getAttribute('data-co-tier'); showError(''); render(); dl.push({ event: 'po_offer_option', funnel: FUNNEL, tier: state.tier, refill: state.refill }); }
    else if ((b = t.closest('[data-co-refill]'))) { state.refill = !state.refill; showError(''); render(); dl.push({ event: 'po_offer_option', funnel: FUNNEL, tier: state.tier, refill: state.refill }); }
    else if ((b = t.closest('[data-co-checkout]'))) { e.preventDefault(); checkout(b); }
  });
  box.addEventListener('keydown', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('[data-co-tier]') : null;
    if (card && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); card.click(); }
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) setBusy(false); });
  render();
})();
